module.exports = __webpack_public_path__ + "static/sign_up-e4e15f079b3097df29d0ab59bfb13a0d.png";